import { CreateReplyController } from '@bakbak/controller';
import * as React from "react";
import { CreateReplyView } from "./CreateReplyView";


interface Props {
  loggedUser: any;
  commentId: string;
  toggleReply: () => void;
}

export class CreateReplyConnector extends React.PureComponent<Props> {
  onComplete = () => {
    this.props.toggleReply();
  }
  render() {
    return (
      <CreateReplyController>
        {({ submit }) =>
          <CreateReplyView
            loggedUser={this.props.loggedUser}
            onComplete={this.onComplete}
            commentId={this.props.commentId}
            submit={submit}
          />
        }
      </CreateReplyController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/reply/create/CreateReplyConnector.tsx